import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { usePrevious } from 'shared/mf-infrastructure/hooks';
import { selectCheckedInfrastructureType } from 'shared/mf-infrastructure/selectors/infrastructure/selectCheckedInfrastructureType';
import { TTAInfrastructureType } from 'shared/mf-infrastructure/types/transportAccessibility';

interface IUseTransportAccessibilityGeoObjectsSyncParams {
  isMapLoaded: boolean;
  isTransportAccessibilityServiceVisible: boolean;
  setTransportAccessibilityGeoObjects: (infrastructureType: TTAInfrastructureType | null) => void;
}

/**
 * Сервис транспортной доступности могли открыть до загрузки карты: тогда вызовы из сайдбара
 * пришлись на пустой mapApi и пины не встали. Повторяет установку пинов выбранного типа
 * один раз — в момент, когда карта стала доступна. Обычные клики по типам сюда не попадают,
 * их обрабатывает сам сайдбар.
 */
export const useTransportAccessibilityGeoObjectsSync = ({
  isMapLoaded,
  isTransportAccessibilityServiceVisible,
  setTransportAccessibilityGeoObjects,
}: IUseTransportAccessibilityGeoObjectsSyncParams) => {
  const checkedType = useSelector(selectCheckedInfrastructureType);
  const wasMapLoaded = usePrevious(isMapLoaded);

  useEffect(() => {
    const isMapJustLoaded = isMapLoaded && !wasMapLoaded;

    if (isMapJustLoaded && isTransportAccessibilityServiceVisible && checkedType) {
      setTransportAccessibilityGeoObjects(checkedType as TTAInfrastructureType);
    }
  }, [
    isMapLoaded,
    wasMapLoaded,
    isTransportAccessibilityServiceVisible,
    checkedType,
    setTransportAccessibilityGeoObjects,
  ]);
};
